var _circle, _circle2, _circle3, _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorAlto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    fill: "#B8B8B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 71.5,
    r: 66.5,
    fill: "#CACACA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 63,
    fill: "url(#paint0_radial)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 22,
    width: 44,
    height: 29,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.966 42.944L53.636 44H53.12L54.47 39.866H55.13L56.474 44H55.934L55.604 42.944H53.966ZM55.466 42.512L54.788 40.31L54.104 42.512H55.466ZM58.4337 43.22C58.4337 43.504 58.6077 43.646 58.9557 43.646C59.1197 43.646 59.2957 43.61 59.4837 43.538L59.6157 43.904C59.4157 44.012 59.1657 44.066 58.8657 44.066C58.5817 44.066 58.3537 43.988 58.1817 43.832C58.0137 43.676 57.9297 43.464 57.9297 43.196V39.968H56.9577V39.566H58.4337V43.22ZM63.3093 43.838C63.2013 43.91 63.0693 43.966 62.9133 44.006C62.7613 44.046 62.6093 44.066 62.4573 44.066C62.1253 44.066 61.8653 43.98 61.6773 43.808C61.4893 43.632 61.3953 43.402 61.3953 43.118V41.234H60.6693V40.838H61.3953V40.124L61.8993 40.064V40.838H62.9973L62.9313 41.234H61.8993V43.112C61.8993 43.292 61.9473 43.426 62.0433 43.514C62.1393 43.602 62.2933 43.646 62.5053 43.646C62.7213 43.646 62.9233 43.596 63.1113 43.496L63.3093 43.838ZM65.599 40.772C66.035 40.772 66.369 40.92 66.601 41.216C66.837 41.508 66.955 41.908 66.955 42.416C66.955 42.912 66.835 43.312 66.595 43.616C66.359 43.916 66.025 44.066 65.593 44.066C65.157 44.066 64.821 43.92 64.585 43.628C64.349 43.332 64.231 42.93 64.231 42.422C64.231 41.922 64.349 41.522 64.585 41.222C64.825 40.922 65.163 40.772 65.599 40.772ZM65.599 41.186C65.323 41.186 65.117 41.288 64.981 41.492C64.845 41.696 64.777 42.006 64.777 42.422C64.777 42.838 64.843 43.148 64.975 43.352C65.111 43.552 65.317 43.652 65.593 43.652C65.869 43.652 66.073 43.552 66.205 43.352C66.341 43.148 66.409 42.836 66.409 42.416C66.409 42 66.341 41.692 66.205 41.492C66.073 41.288 65.871 41.186 65.599 41.186Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9189 97.0692L91.7429 97.3786H97.3777L100.152 91.104L100.196 91.2806L102.881 97.3786H108.649L103.497 87.304L108.208 77.8057H102.397L100.196 83.1514L100.152 83.3281L97.8627 77.8057H92.0512L96.8054 87.304L91.9189 97.0692Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1069 88.9826C85.7992 90.0436 85.3586 91.104 84.8748 91.9006C84.4779 92.4299 83.7733 92.8721 83.2015 92.9604H83.0698C82.2772 92.9604 81.3971 92.165 80.7811 90.6624C80.1644 89.116 79.8555 87.4368 79.8555 85.7582C79.8555 84.5218 80.1644 83.6374 80.7811 83.0192C81.2205 82.4004 82.1442 82.0916 83.2015 82.0916C85.3586 82.0916 86.5482 83.328 86.5482 85.7582C86.5482 86.6858 86.4153 87.7456 86.1069 88.9826ZM91.919 83.328C91.6106 81.5611 90.906 80.2352 89.7619 79.3514C88.2646 78.115 85.9758 77.4962 83.2015 77.4962C80.1644 77.4962 77.7427 78.2478 76.3777 79.4848C75.1451 80.7218 74.3967 82.842 74.3967 85.3166V85.4488C74.3967 86.9952 74.6613 88.541 74.969 90.0436C75.2774 91.59 76.0694 92.9604 76.8184 94.153C77.4344 95.2572 78.4911 96.3176 79.5472 96.9358C80.4727 97.554 81.8365 97.8634 83.2015 97.8634C84.6108 97.8634 85.9758 97.3786 87.0313 96.6264C88.0886 96.0082 89.1459 94.9478 89.7619 93.7114C90.3779 92.5188 91.1269 91.104 91.4346 89.6026C91.6106 88.806 91.7872 88.0105 91.919 87.2163C92.007 86.5536 92.0513 85.9348 92.0513 85.3166C92.0513 84.6095 92.007 83.9462 91.919 83.328Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4296 82.3396C66.6746 82.3396 67.8794 83.7258 67.8794 86.067C67.8794 87.6135 67.2634 89.2933 66.2079 90.6624C65.723 91.3683 65.1069 91.9439 64.358 92.341C63.6545 92.7387 62.817 92.9604 61.9375 92.9604V83.456H56.7415V97.3786H60.8359C62.0686 97.3786 63.2582 97.2452 64.358 96.9358C65.4589 96.6709 66.5162 96.2293 67.3963 95.6988C69.245 94.639 70.7429 93.0926 71.6667 91.2806C72.5911 89.4254 73.0323 87.4368 73.0323 85.6255C73.0323 83.1514 72.1504 81.0307 70.9183 79.7937C69.685 78.6011 67.704 77.8057 65.2823 77.8057H56.7415L55.961 82.3396H64.4296Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6835 78.2161C47.1076 77.1405 54.284 77.668 54.284 77.668L53.6207 72.0049L49.7484 72C48.0708 72 46.4788 72.1297 45.2735 72.3021C44.0693 72.4318 42.8639 72.9069 41.8315 73.3381C40.7991 73.6402 39.7661 74.3741 38.863 74.9796C36.7545 76.4474 35.1655 78.693 34.2618 81.1104C33.4012 83.4852 33 86.0323 33 88.4509V97.3889H39.7661V89.3139H46.9092V97.3889H53.6207V79.0329H46.9092V83.6581H40.3688C40.9278 81.4125 42.2594 79.2917 44.6835 78.2161Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71 71) rotate(90) scale(63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFCB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#ECA622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorAlto);
export default __webpack_public_path__ + "static/media/SensorAlto.37c9417055b167511bd523083b1f3d86.svg";
export { ForwardRef as ReactComponent };